import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useSetDetail, questionFromAssessment } from '@/pages/organizations/detail/sets/detail'
import QuestionDetailPage from '@/pages/organizations/detail/sets/detail/questions/detail'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/sets/$setId/questions/$questionId',
)({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { questionId } = Route.useParams()
  const {
    assessment,
    organization,
    userCanEditActionPlan,
    userCanEditAssessments,
    userCanViewAssessments,
    userCanViewTeam,
  } = useSetDetail()

  const question = questionFromAssessment(assessment, questionId, 'current')
  const prevQuestion = questionFromAssessment(assessment, questionId, 'prev')
  const nextQuestion = questionFromAssessment(assessment, questionId, 'next')

  if (!question) {
    return null
  }

  return (
    <QuestionDetailPage
      organization={organization}
      question={question}
      prevQuestion={prevQuestion}
      nextQuestion={nextQuestion}
      program={assessment?.program}
      userCanEditActionPlan={userCanEditActionPlan}
      userCanEditAssessments={userCanEditAssessments}
      userCanViewAssessments={userCanViewAssessments}
      userCanViewTeam={userCanViewTeam}
    />
  )
}
